enum ActionType {
    REQUEST_THREAT_MEASURES = '[CORE/MEASURES] GET THREAT MEASURES ',
    RECEIVE_THREAT_MEASURES = '[CORE/MEASURES] SET THREAT MEASURES ',
    REQUEST_THREAT_MEASURE_LIMITS = '[CORE/MEASURES] GET LIMITS ',
    RECEIVE_THREAT_MEASURE_LIMITS = '[CORE/MEASURES] SET LIMITS ',
}

export default ActionType
